import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEqual } from 'lodash';
import { default as ModalDefault } from '@components/Modal';
import Button from '@components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GET_PAGES } from '@redux/easyaccess/types';
import PageListItem from './PageListItem';
import * as S from './styles';

class PageSteps extends Component {
  state = {
    pages: [],
    createPage: false,
    badPermission: false,
    showPageSelect: false,
    showModal: false,
  };

  componentDidMount() {
    const {
      props: { step, dispatch, token },
    } = this;

    if (step === 'set_page') {
      dispatch({
        type: GET_PAGES.REQUEST,
        version: '1.0',
        facebookAccessToken: token,
      });

      this.setState({
        showPageSelect: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      props: {
        easyAccessReducer: { pages, step },
      },
    } = this;

    if (!isEqual(prevProps.easyAccessReducer.pages, pages) && !step.isLoading) {
      this.setState({
        pages,
      });
    }
  }

  refreshPages = () => {
    const {
      props: { dispatch, token },
    } = this;

    dispatch({
      type: GET_PAGES.REQUEST,
      version: '1.0',
      facebookAccessToken: token,
    });
  };

  createPage = () => {
    this.setState({
      createPage: true,
      badPermission: false,
    });

    window.open('https://www.facebook.com/pages/create/?ref_type=pages_browser', '_blank');
  };

  bindPage = () => {
    const {
      props: { dispatch, token },
    } = this;

    window.FB.login(
      (response) => {
        if (
          response.authResponse &&
          ((response.authResponse.grantedScopes.includes('pages_manage_ads') &&
            response.authResponse.grantedScopes.includes('pages_manage_posts') &&
            response.authResponse.grantedScopes.includes('pages_read_engagement') &&
            response.authResponse.grantedScopes.includes('pages_manage_metadata') &&
            response.authResponse.grantedScopes.includes('pages_read_user_content') &&
            response.authResponse.grantedScopes.includes('pages_manage_engagement')) ||
            response.authResponse.grantedScopes.includes('manage_pages'))
        ) {
          dispatch({
            type: GET_PAGES.REQUEST,
            version: '1.0',
            facebookAccessToken: token,
          });

          this.setState({
            showPageSelect: true,
            createPage: false,
          });
        } else {
          this.setState({
            createPage: false,
            badPermission: true,
          });
        }
      },
      {
        scope: 'manage_pages, ads_management, publish_pages, instagram_basic, read_insights',
        return_scopes: true,
      }
    );
  };

  render() {
    const {
      state,
      props: { t, token, step },
    } = this;

    return (
      <S.CardWrapper>
        <>
          <ModalDefault
            visible={state.showModal}
            effect="fadeInDown"
            width={530}
            title="Atenção"
            onClickAway={() => this.setState({ showModal: false })}
            cancelButton={() => this.setState({ showModal: false })}
            cancelButtonText="CANCEL"
            confirmButton={() =>
              window.open(
                'https://www.facebook.com/pages/create/?ref_type=pages_browser',
                '_blank'
              ) && this.setState({ showModal: false })
            }
            confirmButtonText="CONFIRM"
            mobileFullScreen
            iconClose={['fal', 'times']}
          >
            <S.ModalContentWrapper>
              Você será direcionado para criar sua página no Facebook. Assim que terminar, retorne
              aqui.
            </S.ModalContentWrapper>
          </ModalDefault>

          {step === 'set_page_scoped_token' && !state.showPageSelect && (
            <div>
              {state.badPermission && (
                <S.ErrorDiv>
                  {' '}
                  <FontAwesomeIcon icon={['fal', 'exclamation-triangle']} /> {t('PERMISSION-ERROR')}
                </S.ErrorDiv>
              )}

              <S.TextBoldWrapper>
                {state.createPage ? t('TEXT-CREATE-PAGE') : t('TEXT-SELECT-BOLD')}
              </S.TextBoldWrapper>

              <S.TextDescriptionWrapper>
                {t('PAGE-MESSAGE')}
                <S.ClickHere onClick={() => this.setState({ showModal: true })}>
                  {t('CLICK-HERE')}
                </S.ClickHere>
                {t('PAGE-MESSAGE-2')}
              </S.TextDescriptionWrapper>
              <S.ButtonWrapper>
                <Button
                  backgroundColor="blue2"
                  type="button"
                  onClick={(e) => this.bindPage(e)}
                  fontSize="16px"
                  size="EAcustom"
                >
                  {t('BUTTON-BIND')}
                </Button>
              </S.ButtonWrapper>
              {/* <ButtonLightWrapper>
                <Button
                    type='button'
                    onClick={e => this.createPage(e) }
                    fontSize='16px'
                    size='EAcustom'
                    disabled={state.createPage}
                    >
                    {t('BUTTON')}
                </Button>
                </ButtonLightWrapper> */}
            </div>
          )}

          {(state.showPageSelect || step === 'set_page') && (
            <S.PageSetWrapper>
              {state.pages && (
                <div>
                  <S.TextBoldWrapperSet>
                    {state.createPage ? t('DESCRIPTION-CREATE-PAGE') : t('TEXT_BOLD_2')}
                  </S.TextBoldWrapperSet>
                  <S.PageListWrapper>
                    {state.pages.map((value, index) => (
                      <PageListItem key={index} page={value} token={token} />
                    ))}
                  </S.PageListWrapper>
                  <S.PageButton onClick={(e) => this.bindPage(e)}>
                    <S.IconCustom>
                      <FontAwesomeIcon icon={['fal', 'link']} />
                    </S.IconCustom>

                    {t('BUTTON-BIND')}
                  </S.PageButton>
                  {/* <PageButton onClick={e => this.createPage(e) }>{t('BUTTON')}</PageButton> */}
                </div>
              )}
            </S.PageSetWrapper>
          )}
        </>
      </S.CardWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  easyAccessReducer: state.easyAccessReducer,
});

export default withRouter(connect(mapStateToProps)(translate('PageSteps')(PageSteps)));
